import day1000 from './day/1000.svg';
import day1003 from './day/1003.svg';
import day1006 from './day/1006.svg';
import day1009 from './day/1009.svg';
import day1030 from './day/1030.svg';
import day1063 from './day/1063.svg';
import day1066 from './day/1066.svg';
import day1069 from './day/1069.svg';
import day1072 from './day/1072.svg';
import day1087 from './day/1087.svg';
import day1114 from './day/1114.svg';
import day1117 from './day/1117.svg';
import day1135 from './day/1135.svg';
import day1147 from './day/1147.svg';
import day1150 from './day/1150.svg';
import day1153 from './day/1153.svg';
import day1168 from './day/1168.svg';
import day1171 from './day/1171.svg';
import day1180 from './day/1180.svg';
import day1183 from './day/1183.svg';
import day1186 from './day/1186.svg';
import day1189 from './day/1189.svg';
import day1192 from './day/1192.svg';
import day1195 from './day/1195.svg';
import day1198 from './day/1198.svg';
import day1201 from './day/1201.svg';
import day1204 from './day/1204.svg';
import day1207 from './day/1207.svg';
import day1210 from './day/1210.svg';
import day1213 from './day/1213.svg';
import day1216 from './day/1216.svg';
import day1219 from './day/1219.svg';
import day1222 from './day/1222.svg';
import day1225 from './day/1225.svg';
import day1237 from './day/1237.svg';
import day1240 from './day/1240.svg';
import day1243 from './day/1243.svg';
import day1246 from './day/1246.svg';
import day1249 from './day/1249.svg';
import day1252 from './day/1252.svg';
import day1255 from './day/1255.svg';
import day1258 from './day/1258.svg';
import day1261 from './day/1261.svg';
import day1264 from './day/1264.svg';
import day1273 from './day/1273.svg';
import day1276 from './day/1276.svg';
import day1279 from './day/1279.svg';
import day1282 from './day/1282.svg';

import night1000 from './night/1000.svg';
import night1003 from './night/1003.svg';
import night1006 from './night/1006.svg';
import night1009 from './night/1009.svg';
import night1030 from './night/1030.svg';
import night1063 from './night/1063.svg';
import night1066 from './night/1066.svg';
import night1069 from './night/1069.svg';
import night1072 from './night/1072.svg';
import night1087 from './night/1087.svg';
import night1114 from './night/1114.svg';
import night1117 from './night/1117.svg';
import night1135 from './night/1135.svg';
import night1147 from './night/1147.svg';
import night1150 from './night/1150.svg';
import night1153 from './night/1153.svg';
import night1168 from './night/1168.svg';
import night1171 from './night/1171.svg';
import night1180 from './night/1180.svg';
import night1183 from './night/1183.svg';
import night1186 from './night/1186.svg';
import night1189 from './night/1189.svg';
import night1192 from './night/1192.svg';
import night1195 from './night/1195.svg';
import night1198 from './night/1198.svg';
import night1201 from './night/1201.svg';
import night1204 from './night/1204.svg';
import night1207 from './night/1207.svg';
import night1210 from './night/1210.svg';
import night1213 from './night/1213.svg';
import night1216 from './night/1216.svg';
import night1219 from './night/1219.svg';
import night1222 from './night/1222.svg';
import night1225 from './night/1225.svg';
import night1237 from './night/1237.svg';
import night1240 from './night/1240.svg';
import night1243 from './night/1243.svg';
import night1246 from './night/1246.svg';
import night1249 from './night/1249.svg';
import night1252 from './night/1252.svg';
import night1255 from './night/1255.svg';
import night1258 from './night/1258.svg';
import night1261 from './night/1261.svg';
import night1264 from './night/1264.svg';
import night1273 from './night/1273.svg';
import night1276 from './night/1276.svg';
import night1279 from './night/1279.svg';
import night1282 from './night/1282.svg';

const iconsMap = {
  day1000,
  day1003,
  day1006,
  day1009,
  day1030,
  day1063,
  day1066,
  day1069,
  day1072,
  day1087,
  day1114,
  day1117,
  day1135,
  day1147,
  day1150,
  day1153,
  day1168,
  day1171,
  day1180,
  day1183,
  day1186,
  day1189,
  day1192,
  day1195,
  day1198,
  day1201,
  day1204,
  day1207,
  day1210,
  day1213,
  day1216,
  day1219,
  day1222,
  day1225,
  day1237,
  day1240,
  day1243,
  day1246,
  day1249,
  day1252,
  day1255,
  day1258,
  day1261,
  day1264,
  day1273,
  day1276,
  day1279,
  day1282,
  night1000,
  night1003,
  night1006,
  night1009,
  night1030,
  night1063,
  night1066,
  night1069,
  night1072,
  night1087,
  night1114,
  night1117,
  night1135,
  night1147,
  night1150,
  night1153,
  night1168,
  night1171,
  night1180,
  night1183,
  night1186,
  night1189,
  night1192,
  night1195,
  night1198,
  night1201,
  night1204,
  night1207,
  night1210,
  night1213,
  night1216,
  night1219,
  night1222,
  night1225,
  night1237,
  night1240,
  night1243,
  night1246,
  night1249,
  night1252,
  night1255,
  night1258,
  night1261,
  night1264,
  night1273,
  night1276,
  night1279,
  night1282,
};

export default iconsMap;
